import request from '../utils/request';


//特装申请
export function  getSpecalApply(){
    return request({
        url:'/frontExhibitor/specialAssembly/view',
        method:'get'
    })
}

//特装申请提交页面
export function saveSpecalApply(data){
    
    console.log('截取的请求参数',data)
    return request({
        url:'/frontExhibitor/specialAssembly/save',
        method:'post',
        data:data
    })

}